import { styled } from "@mui/material/styles";

export const HeyGenContainer = styled("div")(({ theme }) => ({
  width: "100%",
  "& .loader": {
    display: "flex",
    height: "84vh",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    gap: "20px",
    position: "absolute",
    width: "100%",
    left: 0
  },
  "& .avatar-container": {
    position: "relative",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 70px)",
      aspectRatio: "9 / 16",
      borderRadius: "0",
      position: "absolute",
      bottom: 0,
      transition: "all 0.2s ease",
      left: 0,
      width: "100%",
      padding: 0,
    },
    "& video": {
      margin: "30px 0",
      borderRadius: "6px",
      [theme.breakpoints.down("md")]: {
        margin: 0,
        aspectRatio: "9 / 16",
      },
    },
    "& .avatar-bottom-controls": {
        position: "absolute",
        bottom: 0
    },
  },
  "& button": {
    "& p": {
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
  },
  "& .avatar-bottom-controls": {
    display: "flex",
    gap: "20px",
  },
  "& .disconnected": {
    display: "flex",
    height: "84vh",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
}));
